import React, { Component } from 'react';
import {Avatar, Button, CircularProgress, Grid} from '@material-ui/core';
import { Modal, Table, TableBody,TableCell, TableHead, TableRow } from '@material-ui/core';
import moment from 'moment';
import { connect } from "react-redux";
import {BOOKING_DETAILS} from "../../graphql/queries/bookings";
import {AccountCircle, CloseOutlined} from "@material-ui/icons";
import Divider from "@material-ui/core/Divider/Divider";
import TextField from "@material-ui/core/TextField/TextField";
import {NotificationManager} from "react-notifications";

import {USER_PROFILE} from "../../graphql/queries/user";
import { client } from "../../config/apollo";
import { setTransactionFilters, fetchAccounting } from '../../redux/chefs';
import {webFont} from "../../config/theme";
import styles from './styles';
import BookingCard from "../ChefBooking/BookingCard";

const headCells = [
  {
    id: 'tdate',
    numeric: false,
    disablePadding: true,
    label: 'Date',
  },
  {
    id: 'ttype',
    numeric: false,
    disablePadding: true,
    label: 'Type',
  },
  {
    id: 'netAmount',
    numeric: true,
    disablePadding: true,
    label: 'Net Amount',
  },
  {
    id: 'bookingId',
    numeric: false,
    disablePadding: true,
    label: 'Booking Id',
  },
];

class Transactions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openDrawer: false,
      selectedButton: 'week',
      showModal: false,
      bookingDetails: null,
      loadingBooking: false,
      userProfileDetails: null
    };

    this.applyFilters = this.applyFilters.bind(this);
    this.changeSelectedBtn = this.changeSelectedBtn.bind(this);
    this.closeFilterDrawer = this.closeFilterDrawer.bind(this);
    this.openFilterDrawer = this.openFilterDrawer.bind(this);
    this.getTransactionType = this.getTransactionType.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.fetchBookingDetails = this.fetchBookingDetails.bind(this);
    this.getUserProfile = this.getUserProfile.bind(this);
  }

  applyFilters(filters) {
    const {dispatch} = this.props;
    dispatch(setTransactionFilters(filters));
    this.closeFilterDrawer();
  }

  changeSelectedBtn(btnText) {
    if (btnText === 'week') {
      this.setState({ selectedButton: 'week' });
      this.applyFilters({
        endDate: moment().subtract(1, 'days').valueOf(),//.format('DD MMM YYYY'),
        startDate: moment().subtract(8, 'days').valueOf(),//.format('DD MMM YYYY'),
      });
      this.closeFilterDrawer();
    }

    if (btnText === 'filters') {
      this.setState({ selectedButton: 'filters' });
      this.openFilterDrawer();
    }
  }

  closeModal() {
    this.setState({ showModal: false, loadingBooking: false, bookingDetails: null });
  }

  getUserProfile(userId) {
    client.query({
        query: USER_PROFILE,
        variables: { userId },
        fetchPolicy: 'network-only'
      })
      .then(response => {
        if (response.data) {
          if (response.data.userProfile) {
            this.setState({ userProfileDetails: response.data.userProfile });
          }
        }
      })
      .catch(err => {
        console.error('ERR Fetching user profile : ', err);
        this.setState({ userProfileDetails: null });
      });
  };

  fetchBookingDetails(bookingId) {
    try {
      this.setState({ loadingBooking: true, showModal: true });

      client.query({
          query: BOOKING_DETAILS,
          variables: { id: bookingId },
          fetchPolicy: "network-only"
        })
        .then(response => {
          if (response) {
            if (response.data) {
              if (response.data.bookingDetails) {
                this.setState({ bookingDetails: response.data.bookingDetails, loadingBooking: false });
                this.getUserProfile(response.data.bookingDetails.userId);
              } else this.setState({ loadingBooking: false, bookingDetails: null });
            } else this.setState({ loadingBooking: false, bookingDetails: null });
          } else this.setState({ loadingBooking: false, bookingDetails: null });
        })
        .catch(error => {
          console.error('ERR Fetching booking details: ', error);
          this.setState({ loadingBooking: false, bookingDetails: null });
        });
    } catch (err) {
      console.error('ERR Fetching booking details: ', err);
      this.setState({ loadingBooking: false, bookingDetails: null });
    }
  }

  closeFilterDrawer() {
    this.setState({ openDrawer: false });
  }

  openFilterDrawer() {
    this.setState({ openDrawer: true });
  }

  componentDidMount () {
    const {dispatch, userId} = this.props;

    dispatch(fetchAccounting(userId));
  }

  getTransactionType(type) {
    let value = '';

    switch (type) {
      case 'DEBIT':
        value = 'Debit';
        break;

      case 'CREDIT':
        value = 'Credit';
        break;

      case 'PENALTY':
        value = 'Debit (Cancelation penalty)';
        break;

      case 'PAYOUT':
        value = 'Payout';
        break;

      default:
        return '';
    }

    return value;
  }

  render () {
    const { selectedButton } = this.state;
    let { transactions } = this.props;

    if (transactions.length >  0) {
      transactions = [...new Set(transactions)];
      // transactions.sort((a, b) => b.date - a.date);
    }

    const isChef = true;

    return (
      <Grid container>
        {/*<Grid item xs={12}>
          <Button  data-test-id={"lastweek-id"} variant={'outlined'} style={selectedButton === 'week' ? styles.selectedBtn : styles.simpleBtn} onClick={() => this.changeSelectedBtn('week')}>
            <span style={styles.btnText}>Last week</span>
          </Button>

          <Button  data-test-id={"transfilter-id"} variant={'outlined'} style={selectedButton === 'filters' ? styles.selectedBtn : styles.simpleBtn} onClick={() => this.changeSelectedBtn('filters')}>
            <span style={styles.btnText}>Filters</span>
          </Button>
        </Grid>*/}

        <Grid className="transition-table-row" item xs={12} style={{marginTop: 30}}>
          <Table size={'medium'} className="transition-table">
            <TableHead>
            <TableRow>
              {headCells.map(headCell => (
                <TableCell
                  key={headCell.id}
                  align={headCell.numeric ? 'center' : 'left'}
                  padding={'default'}
                >
                  <span style={styles.tableHead}>{headCell.label}</span>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
            <TableBody>
              {transactions.length === 0 && <TableRow>
                <TableCell align={'center'} colSpan={4}>
                  <span style={styles.tableCell}>No Records Found</span>
                </TableCell>
              </TableRow> }
              {transactions.map(tData => (
                <TableRow
                 data-test-id={"trans-bkgid"}
                  key={tData.bookingId}
                  hover
                  tabIndex={-1}
                >
                  <TableCell>
                    <span data-test-id={"trans-bkgdate"} style={styles.tableCell}>{moment.unix(tData.bookingDate/1000).format('MM/DD/YY')}</span>
                  </TableCell>
                  <TableCell>
                    <span data-test-id={"trans-type"} style={styles.tableCell}>{this.getTransactionType(tData.type)}</span>
                  </TableCell>
                  <TableCell align={'right'} style={{ minWidth: 100 }}>
                    <span data-test-id={"trans-netamt"} style={styles.tableCellAmount}>
                      {tData.type.toUpperCase() === 'DEBIT' || tData.type.toUpperCase() === 'PENALTY' ? '-' : ''}$
                      {tData.netAmount}
                    </span>
                  </TableCell>
                  <TableCell>
                    <span
                      onClick={() => {
                        if (tData.type.toUpperCase() !== 'PENALTY')
                          this.fetchBookingDetails(tData.bookingId)
                      }}
                      data-test-id={"trans-bookid"}
                      style={styles.tableBookingId}>
                      {tData.displayId}
                    </span>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <Modal
            open={this.state.showModal}
            onClose={this.closeModal}
          >
            <div className={"booking-details-accounting"}>
              <div className="modal-close">
                <h3 className="modal-close-header">Booking Details</h3>
                <button style={{ border: 'none', background: 'transparent' }} onClick={this.closeModal}>
                  <CloseOutlined />
                </button>
              </div>
              {!this.state.bookingDetails && this.state.loadingBooking && <CircularProgress />}
              {this.state.bookingDetails && <BookingCard booking={this.state.bookingDetails} hideButtons={true} />}
            </div>
          </Modal>
        </Grid>
      </Grid>
    );
  }
}

function mapStateToProps(state) {
  return {
    transactions: state.chefs.transactions,
    transactionFilters: state.chefs.transactionFilters,
    userId: state.auth.userId,
  };
}

export default connect(mapStateToProps)(Transactions);
